export default "__VITE_ASSET__7c2e39cc__"